import React from 'react'
import logo from '../../assets/sk_icon.webp'
import { IoImage } from 'react-icons/io5'

export const Preloader = () => {
    return (
        <div className='w-screen absolute z-50 bg-cream h-[100vh] flex flex-col justify-center items-center'>
            <div className="flex-col gap-4 w-full relative flex items-center justify-center">
                <div className="w-28 absolute h-28 border-8 text-green_s4 text-4xl animate-spin  border-gray-300 flex items-center justify-center border-t-green_s4 rounded-full">

                </div> <img src={logo} className='animate-pulse' />
            </div>
        </div>
    )
}

export const SkeletonLoader = () => {
    return (
        <div className="flex flex-col gap-3 animate-pulse justify-start bg-cream mx-0 desktop:mx-2 rounded-lg h-full p-3">
            <div className="rounded-lg w-full  items-center justify-center flex desktop:w-full tablet:!h-[20vh] h-[25vh] desktop:h-[25vh] bg-gray-300">
                <IoImage className='text-5xl text-gray-200' />
            </div>
            <div className="w-2/4 h-4 mb-3 bg-gray-300  rounded-full"></div>
            <div class="grid grid-cols-3 gap-4">
                <div class="h-2 bg-slate-300 rounded col-span-2"></div>
                <div class="h-2 bg-slate-300 rounded col-span-1"></div>
            </div>
            <div className="h-2 w-full bg-slate-300 rounded"></div>
            <div class="grid grid-cols-3 gap-4">
                <div class="h-2 bg-slate-300 rounded col-span-1"></div>
                <div class="h-2 bg-slate-300 rounded col-span-2"></div>
            </div>
            <div class="grid grid-cols-3 gap-4">
                <div class="h-2 bg-slate-300 rounded col-span-2"></div>
                <div class="h-2 bg-slate-300 rounded col-span-1"></div>
            </div>
            <div className="h-2 mb-3 w-full bg-slate-300 rounded"></div>
            <div class="flex flex-row-reverse w-full gap-4">

                <div class="h-8 w-1/2 bg-green_s1 mt-2 rounded-full col-span-1"></div>
            </div>
        </div>
    )
}

export const SkeletonLoader2 = () => {
    return (
        <div className="flex flex-col gap-3 animate-pulse justify-start mx-0 desktop:mx-2 rounded-lg h-full p-5">
            <div className="rounded-lg w-full object-cover desktop:w-full tablet:h-[20vh] h-[25vh] desktop:h-[25vh] flex justify-center items-center bg-slate-300">
                <IoImage className='text-5xl text-gray-200' />
            </div>
            <div className="w-2/4 h-4 mb-3 bg-gray-300  rounded-full"></div>
            <div class="grid grid-cols-3 gap-4">
                <div class="h-2 bg-slate-300 rounded col-span-2"></div>
                <div class="h-2 bg-slate-300 rounded col-span-1"></div>
            </div>
            <div className="h-2 w-full bg-slate-300 rounded"></div>
            <div class="grid grid-cols-3 gap-4">
                <div class="h-2 bg-slate-300 rounded col-span-1"></div>
                <div class="h-2 bg-slate-300 rounded col-span-2"></div>
            </div>
            <div class="grid grid-cols-3 gap-4">
                <div class="h-2 bg-slate-300 rounded col-span-2"></div>
                <div class="h-2 bg-slate-300 rounded col-span-1"></div>
            </div>
            <div className="h-2 mb-3 w-full bg-slate-300 rounded"></div>
            <div class="flex flex-row-reverse w-full gap-4">

                <div class="h-8 w-1/2 bg-green_s1 mt-2 rounded-full col-span-1"></div>
            </div>
        </div>
    )
}

export const SkeletonLoader3 = () => {
    return (
        <div className="flex flex-col gap-3 animate-pulse justify-start mx-0 desktop:mx-2 rounded-lg h-full p-5">
            <div className="rounded-lg w-full object-cover desktop:w-full tablet:h-[20vh] h-[25vh] desktop:h-[25vh] flex justify-center items-center bg-slate-300">
                <IoImage className='text-5xl text-gray-200' />
            </div>
            <div className="w-2/4 h-4 mb-3 bg-gray-300  rounded-full"></div>
            <div class="grid grid-cols-3 gap-4">
                <div class="h-2 bg-slate-300 rounded col-span-2"></div>
                <div class="h-2 bg-slate-300 rounded col-span-1"></div>
            </div>
            <div className="h-2 w-full bg-slate-300 rounded"></div>
            <div class="grid grid-cols-3 gap-4">
                <div class="h-2 bg-slate-300 rounded col-span-1"></div>
                <div class="h-2 bg-slate-300 rounded col-span-2"></div>
            </div>
            <div class="grid grid-cols-3 gap-4">
                <div class="h-2 bg-slate-300 rounded col-span-2"></div>
                <div class="h-2 bg-slate-300 rounded col-span-1"></div>
            </div>
            <div className="h-2 mb-3 w-full bg-slate-300 rounded"></div>
            <div class="flex flex-row w-full gap-4">

                <div class="h-8 w-1/2 bg-green_s1 mt-2 rounded-full col-span-1"></div>
            </div>
        </div>
    )
}

export const VettingSkeletonLoader = () => (
    <div className="flex flex-col gap-4 animate-pulse">
        <div className="w-1/4 bg-black/50 h-7 rounded"></div>
        <div className="flex flex-row gap-2 w-3/4 items-center">
            <div className="w-5 h-5 rounded-full bg-slate-200"></div>
            <div className="w-full bg-slate-200 h-5"></div>
        </div>
        <div className="flex w-3/4 flex-row gap-2 items-center">
            <div className="w-5 h-5 rounded-full bg-slate-200"></div>
            <div className="w-full bg-slate-200 h-5"></div>
        </div>
        <div className="flex w-3/4 flex-row gap-2 items-center">
            <div className="w-5 h-5 rounded-full bg-slate-200"></div>
            <div className="w-full bg-slate-200 h-5"></div>
        </div>
        <div className="w-3/4 bg-slate-200 h-20 rounded mb-4">

        </div>
        <div className="flex w-full justify-end items-end gap-4">
            <div className="w-36 h-8 rounded bg-slate-400/60"></div>
            <div className="w-36 h-8 rounded bg-green_s4/60"></div>
        </div>

    </div>
)